import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { map } from "lodash";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import AuditCard from "components/Common/AuditCard2.0";
import TableComponent from "components/Common/TableComponent";
import OperationList from "components/Common/OperationListHm";
import DocumentHm from "components/Common/DocumentImpressionHm";
import DocumentFusionHm from "components/Common/DocumentFusionHm";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import SectionCard from "components/Common/SectionCard";
import ImpressionsHmListModele from "components/Common/ImpressionsHmListModele";
import InvestisseursHm from "components/Common/InvestisseursHm(mesCgps)";
import DeleteButton from "components/Common/DeleteButtonShow";

import Config from "config";
import AuditInfo from "components/Common/AuditCardSouscription";
const ConfigMessagerieDetail = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);

  const toggleModal = () => setModal(!modal);
  const [impression, setCgpData] = useState([]);

  const [investisseurs, setInvestisseurs] = useState([]);
  const [documentData, setDocumentData] = useState([]);
  const [btnsecondary1, setBtnsecondary1] = useState(false);

  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  const toggle = () => setModal(!modal);
  const [data, setData] = useState("");
  const handleDelete = async (action) => {
    toast.success("Suppression en cours...");
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/${action.controlleur}/${action.params.impression_id}/${action.action}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const impression = await response.json();
      if (response.status == 200) {
        toast.success(impression.message);
      } else {
        throw new Error(
          "La requête a échoué avec le statut " + response.status
        );
      }
      toggle();
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  const handleDropDownActionsClick = async (action, dynamicSegment) => {
    switch (action.action) {
      case "verifier_identifiants":
        const generateRedirectLink = (actionObj, dynamicSegment) => {
          if (!actionObj || !actionObj.controlleur || !actionObj.action) {
            console.log("Contrôleur ou action manquante");
            toast.error("Action invalide !");
            return null;
          }

          // Définir la base URL avec la variable dynamique
          const baseUrl = `${window.location.origin}/${dynamicSegment}/${actionObj.controlleur}/${actionObj.action}`;
          const url = new URL(baseUrl);

          // Ajouter les paramètres s'il y en a
          if (actionObj.params && typeof actionObj.params === "object") {
            Object.entries(actionObj.params).forEach(([key, value]) => {
              url.searchParams.set(key, value);
            });
          }

          return url.toString();
        };

        const redirectLink = generateRedirectLink(action, dynamicSegment);
        if (redirectLink) {
          window.location.href = redirectLink + `&token=${token}`; // Redirection immédiate
        }
        break;

      default:
        toast.error("Aucune action configurée");
        break;
    }
  };

  document.title = "Compte de messagerie | DETAILS";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const navStyleClient = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
      textAlign: "left",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={{ ...(type_compte == "client" ? navStyleClient : navStyle) }}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {type_compte == "client" && !loading ? (
              "Détails " + impression.sil
            ) : !loading ? (
              "Détails Compte de messagerie"
            ) : (
              <span
                className="placeholder col-3"
                style={{ height: "1em" }}
              ></span>
            )}
          </NavLink>
        </NavItem>
        {impression?.hm_accessibles?.map((key, index) =>
          key === "hm_investisseurs" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "investisseurs" ? "active" : ""
                }`}
                onClick={() => handleTabClick("investisseurs")}
              >
                {!loading ? (
                  investisseurs?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_documents" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "documents" ? "active" : ""
                }`}
                onClick={() => handleTabClick("documents")}
              >
                {!loading ? (
                  documentData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : null
        )}
      </Nav>
    );
  };

  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/smtp_parametres/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const impression = await response.json();
        setCgpData(impression);
        {
          impression?.hm_accessibles?.map(async (key, index) =>
            key === "hm_documents" ? await getDocumentHm() : null
          );
        }
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };

    const getDocumentHm = async () => {
      try {
        await fetch(
          `https://www.fluxod.com/${api}/smtp_parametres/${id}/hm_documents`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            setDocumentData(data);
          });
      } catch (error) {
        console.log(error);
      }
    };

    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }
  const handleGoBack = () => {
    window.history.back(); // Cela vous ramènera en arrière dans l'historique du navigateur
  };
  const type_compte = localStorage.getItem("typeDeCompte_" + api);
  return (
    <React.Fragment>
      <div>
        <Button color="danger" onClick={toggle}>
          Supprimer
        </Button>
        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>Confirmation</ModalHeader>
          <ModalBody>
            Êtes-vous sûr de vouloir supprimer ce document ?
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => handleDelete(data)}>
              Oui
            </Button>{" "}
            <Button color="secondary" onClick={toggle}>
              Annuler
            </Button>
          </ModalFooter>
        </Modal>
      </div>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/smtp_parametres`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        Compte de messagerie
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        impression.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-center align-items-center w-100 position-relative">
                    {/* Alerte placée au centre */}
                    {impression?.detail_smtp_parametre?.Identification[
                      "Compte vérifié"
                    ] === "Non" && (
                      <div className="alert alert-warning d-flex align-items-center py-1 px-3 mb-0 mt-2 position-absolute start-50 translate-middle-x">
                        <i className="bx bx-error-circle me-2"></i>
                        Veuillez lancer l'action de vérification des
                        identifiants
                      </div>
                    )}

                    {/* Boutons placés à droite */}
                    <div className="d-flex align-items-center ms-auto">
                      {impression.can_edit && (
                        <Link
                          to={`${backUrl}/smtp_parametres/${id}/edit`}
                          state={linkState}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-edit-alt"></i> Modifier
                        </Link>
                      )}
                      &nbsp;
                      {impression.can_destroy && (
                        <DeleteButton
                          url={`https://www.fluxod.com/${api}/smtp_parametres/${id}`}
                        />
                      )}
                      &nbsp;
                      {impression?.actions?.length > 0 && (
                        <Dropdown
                          isOpen={btnsecondary1}
                          toggle={() => setBtnsecondary1(!btnsecondary1)}
                        >
                          <DropdownToggle
                            tag="button"
                            className="btn btn-sm btn-secondary"
                          >
                            Actions <i className="mdi mdi-chevron-down" />
                          </DropdownToggle>
                          <DropdownMenu>
                            {impression?.actions.map((value, index) => (
                              <DropdownItem
                                key={index}
                                onClick={() =>
                                  handleDropDownActionsClick(value.action, api)
                                }
                              >
                                {value.label}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      )}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              {impression?.detail_smtp_parametre
                                ?.Identification ? (
                                <IdentificationCard
                                  title="Identification"
                                  ids={impression?.detail_smtp_parametre?.ids}
                                  details={
                                    impression?.detail_smtp_parametre
                                      ?.Identification
                                  }
                                />
                              ) : null}
                            </Col>

                            {impression?.detail_smtp_parametre?.Audit ? (
                              <AuditInfo
                                createdOn={
                                  impression?.detail_smtp_parametre?.Audit?.[
                                    "Créé le"
                                  ]
                                }
                                createdBy={
                                  impression?.detail_smtp_parametre?.Audit?.[
                                    "Créé par"
                                  ]
                                }
                                modifiedOn={
                                  impression?.detail_smtp_parametre?.Audit?.[
                                    "Modifié le"
                                  ]
                                }
                                modifiedBy={
                                  impression?.detail_smtp_parametre?.Audit?.[
                                    "Modifié par"
                                  ]
                                }
                              />
                            ) : null}
                            <Col sm="12">{/*  */}</Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default ConfigMessagerieDetail;
